export type WalletLoginErrorType = 'USER_REJECTED' | 'UNCONNECTED' | 'SERVER_ERROR' | 'UNKNOWN';

export interface WalletLoginError {
    type: WalletLoginErrorType;
    message: string;
}

const getErrorMessage = (error: unknown): string => {
    if (error instanceof Error) return error.message;
    if (typeof error === 'string') return error;
    if (error && typeof error === 'object' && 'message' in error) {
        return String((error as { message?: unknown }).message || '');
    }
    return '';
};

const getErrorCode = (error: unknown): number | string | undefined => {
    if (error && typeof error === 'object' && 'code' in error) {
        return (error as { code?: number | string }).code;
    }
    return undefined;
};

export const normalizeWalletLoginError = (error: unknown): WalletLoginError => {
    const code = getErrorCode(error);
    const message = getErrorMessage(error);
    const lowerMessage = message.toLowerCase();

    if (message === 'WAIT_LOGIN_TIMEOUT') {
        return { type: 'UNKNOWN', message: 'Wallet login timed out. Please try again.' };
    }

    if (code === 4001 || lowerMessage.includes('user rejected') || lowerMessage.includes('user denied')) {
        return { type: 'USER_REJECTED', message: 'Signature was cancelled.' };
    }

    if (message === 'UNCONNECTED_ERROR' || lowerMessage.includes('wallet unconnection')) {
        return { type: 'UNCONNECTED', message: 'Wallet is not connected.' };
    }

    if (lowerMessage.includes('login') || lowerMessage.includes('network') || lowerMessage.includes('server')) {
        return { type: 'SERVER_ERROR', message: message || 'Wallet login failed.' };
    }

    return { type: 'UNKNOWN', message: message || 'Wallet login failed.' };
};
